export const STREAMERS = {
  ye: {
    displayName: "YE",
    avatar: "https://yeezy-avatars.s3.us-east-1.amazonaws.com/Ye-profilepic.jpg",
    items: [
      // { vodId: "ep1-live", type: "live" },

      // {
      //   vodId: "ep1-replay",
      //   type: "vod",
      //   title: "YE in KOREA HQ (No FULL LIVE) 2025 BY CHANNEL CANDY",
      //   playbackUrlVod:
      //     "https://d2hfvzg128c2og.cloudfront.net/yefanatics-yekorea/master.m3u8",
      //   thumbnail: "/thumbs/ep1_replay.jpg",
      // },
    ],
  },
  digitalnas: {
    displayName: "DIGITAL NAS",
    avatar: "https://yeezy-avatars.s3.us-east-1.amazonaws.com/digitalnas.jpg",
    items: [
      {
        vodId: "ep1-replay",
        type: "vod",
        title: "Hassan Khaffaf x Digital Nas Full Interview",
        playbackUrlVod:
          "https://d2hfvzg128c2og.cloudfront.net/digital-nas-hassan-full-interview/master.m3u8",
        thumbnail: "/thumbs/ep1_replay.jpg",
      },
    ],
  },

 hassan: {
    displayName: "HASSAN KHAFFAF",
    avatar: "https://yeezy-avatars.s3.us-east-1.amazonaws.com/hassan.jpg",
    items: [
      {
        vodId: "hassan-ep2",
        type: "vod",
        title: "Hassan & Choir (Rehearsal)",
        playbackUrlVod:
          "https://d2hfvzg128c2og.cloudfront.net/hassanandchoir2/master.m3u8",
        // if you actually have an ep2 thumb, use it; otherwise keep as-is
        thumbnail: "/thumbs/hassan_ep1.jpg",
      },
    ],
  },


  sneako: {
    displayName: "SNEAKO",
    avatar: "https://yeezy-avatars.s3.us-east-1.amazonaws.com/sneako.jpg",
    items: [
      { vodId: "sneako-live", type: "live" },

      {
        vodId: "hassan-ep1",
        type: "vod",
        title:
          "Hassan X Sneako Anything is Possible Premiere",
        playbackUrlVod:
          "https://d2hfvzg128c2og.cloudfront.net/hassan-sneako/master.m3u8",
        thumbnail: "/thumbs/hassan_ep1.jpg",
      },
    ],
  },

    spirit: {
    displayName: "SPIRIT",
    avatar: "https://yeezy-avatars.s3.us-east-1.amazonaws.com/spiritp.jpg",
    items: [
      { vodId: "ep1-live", type: "live" },

      {
  vodId: "tnr1",
  type: "vod",
  title: "THIS IS SERIOUS NOW - TNR1",
  playbackUrlVod:
    "https://d2hfvzg128c2og.cloudfront.net/NR.EP1/master.m3u8",
  thumbnail: "/thumbs/ep1_replay.jpg",
},
      {
        vodId: "ep1-replay",
        type: "vod",
        title: "Yeezy Stream Event 2025 - The First Yeezy Stream",
        playbackUrlVod:
          "https://d2hfvzg128c2og.cloudfront.net/spirit-first-stream/master.m3u8",
        thumbnail: "/thumbs/ep1_replay.jpg",
      },


    ],
  },

      yefanatics: {
    displayName: "YEFANATICS",
    avatar: "https://yeezy-avatars.s3.us-east-1.amazonaws.com/yefanatics.jpg",
    items: [
      { vodId: "ep1-live", type: "live" },

      {
        vodId: "ep1-replay",
        type: "vod",
        title: "YE IN KOREA HQ (NO FULL LIVE) 2025 BY CHANNEL CANDY",
        playbackUrlVod:
          "https://d2hfvzg128c2og.cloudfront.net/yefanatics-yekorea/master.m3u8",
        thumbnail: "/thumbs/ep1_replay.jpg",
      },
    ],
  },



};
